import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import Translate from "../../utils/Translate";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import DigitalLicenseListPage from "./DigitalLicenseListPage";
import DigitalPermitListPage from "./DigitalPermitListPage";
import { useSearchParams } from "react-router-dom";

export default function ECompStartPage() {
  const [searchParams] = useSearchParams();
  const startTab = searchParams.get("startTab");
  const [tab, setTab] = useState(startTab);

  return (
    <TabContext value={tab}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TabList onChange={(_, newTab) => setTab(newTab)}>
          <Tab label={Translate.get("Licences")} value="0" />
          <Tab label={Translate.get("ActorPermit")} value="1" />
        </TabList>
      </Box>
      <TabPanel value="0">
        <DigitalLicenseListPage />
      </TabPanel>
      <TabPanel value="1">
        <DigitalPermitListPage />
      </TabPanel>
    </TabContext>
  );
}
